/**
 * Extracts the JavaScript function code and description from a string containing markdown code blocks
 * @param text - Text with potential Markdown code block and description
 * @returns Object containing the function code and description
 */
export function extractFunctionAndDescription(text: string): { functionJs: string, description: string } {
	// Regular expression to match JavaScript code block and capture the content
	const codeRegex = /```(?:javascript|js)\s*\n([\s\S]*?)\n```/m;

	// Extract the function code
	const codeMatch = text.match(codeRegex);
	const functionJs = codeMatch ? codeMatch[1].trim() : "";

	// Extract the description (text after the code block)
	let description = "";
	if (codeMatch) {
		const codeEndIndex = text.indexOf("```", text.indexOf(codeMatch[1]) + codeMatch[1].length);
		if (codeEndIndex !== -1) {
			description = text.substring(codeEndIndex + 3).trim();
		}
	}
	return { functionJs, description };
}